export const TEAM_DEPARTMENTS = {
  HOUSEKEEPING: 'HOUSEKEEPING',
  PROPERTY_MANAGEMENT: 'PROPERTY_MANAGEMENT',
  MAINTENANCE: 'MAINTENANCE',
  RESERVATIONS: 'RESERVATIONS',
};

export const TEAM_DEPARTMENT_LABELS = {
  HOUSEKEEPING: 'Housekeeping',
  PROPERTY_MANAGEMENT: 'Property Management',
  MAINTENANCE: 'Maintenance',
  RESERVATIONS: 'Reservations',
};

export const TEAM_DEPARTMENT_OPTIONS = Object.entries(TEAM_DEPARTMENT_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export function getTeamDepartmentLabel(department) {
  return TEAM_DEPARTMENT_LABELS[department] || 'No department';
}

// Team status constants
export const TEAM_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

// Default team colors for UI
export const DEFAULT_TEAM_COLORS = [
  '#3B82F6', // Blue
  '#10B981', // Green
  '#F59E0B', // Yellow
  '#EF4444', // Red
  '#8B5CF6', // Purple
  '#F97316', // Orange
  '#06B6D4', // Cyan
  '#84CC16', // Lime
  '#EC4899', // Pink
  '#6B7280'  // Gray
];

// Team form validation
export const validateTeamForm = (formData) => {
  const errors = {};
  
  if (!formData.name?.trim()) {
    errors.name = 'Team name is required';
  } else if (formData.name.trim().length > 50) {
    errors.name = 'Team name must be 50 characters or less';
  }
  
  if (formData.description && formData.description.length > 255) {
    errors.description = 'Description must be 255 characters or less';
  }
  
  if (formData.color && !/^#[0-9A-F]{6}$/i.test(formData.color)) {
    errors.color = 'Color must be a valid hex color code (e.g., #FF5733)';
  }
  
  if (!formData.department) {
    errors.department = 'Department is required';
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Default form data for creating teams
export const getDefaultTeamFormData = () => ({
  name: '',
  description: '',
  color: DEFAULT_TEAM_COLORS[0],
  isContractor: false,
  department: '',
});

// Get team color or return default
export const getTeamColor = (team) => {
  return team?.color || DEFAULT_TEAM_COLORS[0];
};

// Get team display name
export const getTeamDisplayName = (team) => {
  return team?.name || 'No Team';
};

export function getTeamMemberDisplayName(member) {
  if (!member) return '';
  const fullName = `${member.firstName || ''} ${member.lastName || ''}`.trim();
  return fullName || member.email || 'Unknown member';
}

export function getAssignedTeamMembers(team) {
  if (!team) return [];
  const seen = new Set();
  const members = [];
  const candidates = [
    ...(team.userTeams || []).map((membership) => membership.user),
    ...(team.members || []),
  ];
  candidates.forEach((member) => {
    if (!member || member.isActive === false) return;
    const key = member.id != null ? String(member.id) : getTeamMemberDisplayName(member);
    if (!key || seen.has(key)) return;
    seen.add(key);
    members.push(member);
  });
  return members;
}

// Sort teams by name
export const sortTeams = (teams) => {
  return [...teams].sort((a, b) => a.name.localeCompare(b.name));
};

// Filter active teams
export const getActiveTeams = (teams) => {
  return teams.filter(team => team.isActive);
}; 